import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  copyToArray2j022khrow2yi as copyToArray,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import {
  addClass1ihnmxbr5xjr2 as addClass,
  hasClass3787e36stqarb as hasClass,
  removeClass3jnpygopqxh7s as removeClass,
} from '../../../../../kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat/kotlinx/dom/Classes.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  KtMutableSetwuwn7k5m570a as KtMutableSet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { json3n35pf5np6si4 as json } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/json.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Default_getInstancee1f46otjvolq as Default_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
import {
  until1jbpn0z3f8lbg as until,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { iterator2ui8u8e1d2x5o as iterator } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/dynamic.mjs';
import { get_native16zxqjg6lrtlz as get_native } from './NativeElement.commonHtml.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { get_px1lajc6xaddk2r as get_px } from '../models/data.js.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../models/data.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  DragData2helsigoeiabk as DragData,
  DragEventn7vmft816tmz as DragEvent,
} from '../models/DragData.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FutureElement$ClassSet$iterator$1Class;
function FutureElement$ClassSet$iterator$1() {
  if (FutureElement$ClassSet$iterator$1Class === VOID) {
    class $ {
      constructor($index, $list) {
        this.$index_1 = $index;
        this.$list_1 = $list;
      }
      hasNext_bitz1p_k$() {
        return this.$index_1._v < this.$list_1.length;
      }
      get_last_wopotb_k$() {
        var tmp = this.last_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('last');
        }
      }
      next_20eer_k$() {
        var tmp = this;
        var tmp0_elvis_lhs = this.$list_1.item(this.$index_1._v);
        tmp.last_1 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
        var _unary__edvuaz = this.$index_1._v;
        this.$index_1._v = _unary__edvuaz + 1 | 0;
        return this.get_last_wopotb_k$();
      }
      remove_ldkf9o_k$() {
        this.$list_1.remove(this.get_last_wopotb_k$());
        var _unary__edvuaz = this.$index_1._v;
        this.$index_1._v = _unary__edvuaz - 1 | 0;
      }
    }
    initMetadataForClass($);
    FutureElement$ClassSet$iterator$1Class = $;
  }
  return FutureElement$ClassSet$iterator$1Class;
}
function _set_element__ae2pkn($this, value) {
  $this.element_1 = value;
  var tmp = $this.style_1;
  var tmp0_safe_receiver = value instanceof HTMLElement ? value : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.style;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = value instanceof SVGElement ? value : null;
    tmp_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.style;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  tmp.native_1 = tmp_0;
  $this.attributes_1.native_1 = value;
}
function assertSizeMatch($this) {
  var tmp0_safe_receiver = $this.element_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    if (!(tmp0_safe_receiver.childElementCount === $this.lastChildren_1.get_size_woubt6_k$()))
      throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Size mismatch - ' + tmp0_safe_receiver.childElementCount + ' vs ' + $this.lastChildren_1.get_size_woubt6_k$());
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var _iterator__ex2g4s = $this.lastChildren_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      if (!equals(item.element_1, tmp0_safe_receiver.children.item(index_0))) {
        console.warn('WARNING: Child order inconsistency at index ' + index_0, tmp0_safe_receiver);
      }
    }
  }
}
var ClassSetClass;
function ClassSet() {
  if (ClassSetClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.map_1 = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
      }
      add_2lb1a1_k$(element) {
        var tmp0_safe_receiver = this.$this_1.element_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : addClass(tmp0_safe_receiver, [element]);
        return tmp1_elvis_lhs == null ? this.map_1.add_utx5q5_k$(element) : tmp1_elvis_lhs;
      }
      add_utx5q5_k$(element) {
        return this.add_2lb1a1_k$((!(element == null) ? typeof element === 'string' : false) ? element : THROW_CCE());
      }
      addAll_kop2uz_k$(elements) {
        var tmp0_safe_receiver = this.$this_1.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.collections.toTypedArray' call
          var tmp$ret$0 = copyToArray(elements);
          tmp = addClass(tmp0_safe_receiver, tmp$ret$0.slice());
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? this.map_1.addAll_4lah1e_k$(elements) : tmp1_elvis_lhs;
      }
      addAll_4lah1e_k$(elements) {
        return this.addAll_kop2uz_k$(elements);
      }
      get_size_woubt6_k$() {
        var tmp0_safe_receiver = this.$this_1.element_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.classList;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
        return tmp2_elvis_lhs == null ? this.map_1.get_size_woubt6_k$() : tmp2_elvis_lhs;
      }
      isEmpty_y1axqb_k$() {
        var tmp0_safe_receiver = this.$this_1.element_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.className;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : isBlank(tmp1_safe_receiver);
        return tmp2_elvis_lhs == null ? this.map_1.isEmpty_y1axqb_k$() : tmp2_elvis_lhs;
      }
      containsAll_udwr5v_k$(elements) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp;
          if (isInterface(elements, Collection())) {
            tmp = elements.isEmpty_y1axqb_k$();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = elements.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (!this.contains_zh0gsb_k$(element)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      containsAll_xk45fg_k$(elements) {
        return this.containsAll_udwr5v_k$(elements);
      }
      contains_zh0gsb_k$(element) {
        var tmp0_safe_receiver = this.$this_1.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = hasClass(tmp0_safe_receiver, element);
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? this.map_1.contains_aljjnj_k$(element) : tmp1_elvis_lhs;
      }
      contains_aljjnj_k$(element) {
        if (!(!(element == null) ? typeof element === 'string' : false))
          return false;
        return this.contains_zh0gsb_k$((!(element == null) ? typeof element === 'string' : false) ? element : THROW_CCE());
      }
      iterator_jk1svi_k$() {
        var tmp0_safe_receiver = this.$this_1.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var index = {_v: 0};
          var list = tmp0_safe_receiver.classList;
          tmp = new (FutureElement$ClassSet$iterator$1())(index, list);
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? this.map_1.iterator_jk1svi_k$() : tmp1_elvis_lhs;
      }
      remove_z05dva_k$(element) {
        var tmp0_safe_receiver = this.$this_1.element_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : removeClass(tmp0_safe_receiver, [element]);
        return tmp1_elvis_lhs == null ? this.map_1.remove_cedx0m_k$(element) : tmp1_elvis_lhs;
      }
      remove_cedx0m_k$(element) {
        if (!(!(element == null) ? typeof element === 'string' : false))
          return false;
        return this.remove_z05dva_k$((!(element == null) ? typeof element === 'string' : false) ? element : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ClassSet', VOID, VOID, [KtMutableSet()]);
    ClassSetClass = $;
  }
  return ClassSetClass;
}
function FutureElement$click$lambda(it) {
  (it instanceof HTMLElement ? it : THROW_CCE()).click();
  return Unit_instance;
}
function FutureElement$focus$lambda(it) {
  (it instanceof HTMLElement ? it : THROW_CCE()).focus();
  return Unit_instance;
}
var FutureElementClass;
function FutureElement() {
  if (FutureElementClass === VOID) {
    class $ {
      constructor() {
        this.elementToDo_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.element_1 = null;
        this.xmlns_1 = null;
        this.tag_1 = 'tag';
        this.attributesBack_1 = json([]);
        this.attributes_1 = new (FutureElementAttributes())(this.attributesBack_1);
        this.styleBack_1 = json([]);
        this.style_1 = new (FutureElementStyle())(this.styleBack_1);
        this.desiredVerticalGravity_1 = null;
        this.desiredHorizontalGravity_1 = null;
        this.eventsBack_1 = json([]);
        this.futureStyles_1 = json([]);
        this.futureAttributes_1 = json([]);
        this.classes_1 = new (ClassSet())(this);
        this.id_1 = null;
        this.content_1 = null;
        this.innerHtmlUnsafe_1 = null;
        this.lastChildren_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      get_actualElementForLeakTracking_nchncy_k$() {
        return this.element_1;
      }
      create_md4cuc_k$() {
        var tmp0_safe_receiver = this.element_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return tmp0_safe_receiver;
        }
        var tmp1_safe_receiver = this.xmlns_1;
        var tmp;
        if (tmp1_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = document.createElementNS(tmp1_safe_receiver, this.tag_1);
        }
        var tmp2_elvis_lhs = tmp;
        var e = tmp2_elvis_lhs == null ? document.createElement(this.tag_1) : tmp2_elvis_lhs;
        var tmp3_safe_receiver = this.id_1;
        if (tmp3_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          e.id = tmp3_safe_receiver;
        }
        // Inline function 'com.lightningkite.kiteui.views.objectAssign' call
        var source = this.attributesBack_1;
        Object.assign(e, source);
        var tmp4_safe_receiver = e instanceof HTMLElement ? e : null;
        var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.style;
        var tmp_0;
        if (tmp5_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          var it = tmp5_safe_receiver;
          // Inline function 'com.lightningkite.kiteui.views.objectAssign' call
          var source_0 = this.styleBack_1;
          Object.assign(it, source_0);
          forEach(this.futureStyles_1, (k, v) => {
            it.setProperty(k, v);
            return Unit_instance;
          });
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          var tmp7_safe_receiver = e instanceof SVGElement ? e : null;
          var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.style;
          if (tmp8_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var it_0 = tmp8_safe_receiver;
            // Inline function 'com.lightningkite.kiteui.views.objectAssign' call
            var source_1 = this.styleBack_1;
            Object.assign(it_0, source_1);
            forEach(this.futureStyles_1, (k, v) => {
              it_0.setProperty(k, v);
              return Unit_instance;
            });
          }
        }
        forEach(this.futureAttributes_1, (k, v) => {
          e.setAttribute(k, v);
          return Unit_instance;
        });
        var tmp9_safe_receiver = this.content_1;
        if (tmp9_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver_0 = e instanceof HTMLElement ? e : null;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            tmp0_safe_receiver_0.innerText = tmp9_safe_receiver;
          }
        }
        var tmp10_safe_receiver = this.innerHtmlUnsafe_1;
        if (tmp10_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver_1 = e instanceof HTMLElement ? e : null;
          if (tmp0_safe_receiver_1 == null)
            null;
          else {
            tmp0_safe_receiver_1.innerHTML = tmp10_safe_receiver;
          }
        }
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.get_children_4cwbp4_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          e.appendChild(element.create_md4cuc_k$());
        }
        var tmp_1;
        if ((e instanceof HTMLElement ? e : null) == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          e.className = joinToString(this.classes_1, ' ');
          tmp_1 = Unit_instance;
        }
        if (tmp_1 == null) {
          // Inline function 'kotlin.run' call
          var tmp_2 = e.classList;
          // Inline function 'kotlin.collections.toTypedArray' call
          var this_0 = this.classes_1;
          var tmp$ret$23 = copyToArray(this_0);
          (function () {
            var $externalVarargReceiverTmp = tmp_2;
            return $externalVarargReceiverTmp.add.apply($externalVarargReceiverTmp, [].slice.call(tmp$ret$23.slice()));
          }.call(this));
        }
        // Inline function 'com.lightningkite.kiteui.views.objectAssign' call
        var source_2 = this.eventsBack_1;
        Object.assign(e, source_2);
        _set_element__ae2pkn(this, e);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = this.elementToDo_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          element_0(e);
        }
        return e;
      }
      click_jclltk_k$() {
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
        var tmp0_safe_receiver = this.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          (tmp0_safe_receiver instanceof HTMLElement ? tmp0_safe_receiver : THROW_CCE()).click();
          tmp = Unit_instance;
        }
        if (tmp == null) {
          this.elementToDo_1.add_utx5q5_k$(FutureElement$click$lambda);
        }
      }
      focus_of07w8_k$() {
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
        var tmp0_safe_receiver = this.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          (tmp0_safe_receiver instanceof HTMLElement ? tmp0_safe_receiver : THROW_CCE()).focus();
          tmp = Unit_instance;
        }
        if (tmp == null) {
          this.elementToDo_1.add_utx5q5_k$(FutureElement$focus$lambda);
        }
      }
      setStyleProperty_wavvb3_k$(key, value) {
        var element = this.element_1;
        if (element == null) {
          if (value == null) {
            remove(this.futureStyles_1, key);
          } else {
            this.futureStyles_1[key] = value;
          }
        } else {
          var tmp0_safe_receiver = element instanceof HTMLElement ? element : null;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.style;
          var tmp;
          if (tmp1_elvis_lhs == null) {
            var tmp2_safe_receiver = element instanceof SVGElement ? element : null;
            tmp = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.style;
          } else {
            tmp = tmp1_elvis_lhs;
          }
          var tmp3_elvis_lhs = tmp;
          var tmp_0;
          if (tmp3_elvis_lhs == null) {
            return Unit_instance;
          } else {
            tmp_0 = tmp3_elvis_lhs;
          }
          var style = tmp_0;
          if (value == null) {
            style.removeProperty(key);
          } else {
            style.setProperty(key, value);
          }
        }
      }
      setAttribute_j9pxft_k$(key, value) {
        var element = this.element_1;
        if (element == null) {
          if (value == null) {
            remove(this.futureAttributes_1, key);
          } else {
            this.futureAttributes_1[key] = value;
          }
        } else {
          if (value == null) {
            element.removeAttribute(key);
          } else {
            element.setAttribute(key, value);
          }
        }
      }
      flushClasses_zcguoe_k$() {
      }
      set_id_wyyipr_k$(value) {
        this.id_1 = value;
        var tmp0_safe_receiver = this.element_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.id = value == null ? Default_getInstance().nextInt_ujorgc_k$().toString() : value;
        }
      }
      set_content_i5lrjv_k$(value) {
        this.content_1 = value;
        if (value == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp = this.element_1;
          var tmp0_safe_receiver = tmp instanceof HTMLElement ? tmp : null;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.innerText = value;
          }
        }
      }
      get_children_4cwbp4_k$() {
        var tmp0_safe_receiver = this.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.let' call
          var it = tmp0_safe_receiver.children;
          // Inline function 'kotlin.collections.map' call
          var this_0 = until(0, it.length);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
          var inductionVariable = this_0.first_1;
          var last = this_0.last_1;
          if (inductionVariable <= last)
            do {
              var item = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var i = item;
              var item_0 = it.item(i);
              // Inline function 'kotlin.collections.find' call
              var tmp0 = this.lastChildren_1;
              var tmp$ret$8;
              $l$block: {
                // Inline function 'kotlin.collections.firstOrNull' call
                var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
                while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
                  var element = _iterator__ex2g4s.next_20eer_k$();
                  if (element.element_1 === item_0) {
                    tmp$ret$8 = element;
                    break $l$block;
                  }
                }
                tmp$ret$8 = null;
              }
              var tmp0_elvis_lhs = tmp$ret$8;
              var tmp_0;
              if (tmp0_elvis_lhs == null) {
                // Inline function 'kotlin.apply' call
                var this_1 = new (FutureElement())();
                _set_element__ae2pkn(this_1, it.item(i));
                tmp_0 = this_1;
              } else {
                tmp_0 = tmp0_elvis_lhs;
              }
              var tmp$ret$6 = tmp_0;
              destination.add_utx5q5_k$(tmp$ret$6);
            }
             while (!(item === last));
          // Inline function 'kotlin.also' call
          this.lastChildren_1.clear_j9egeb_k$();
          this.lastChildren_1.addAll_4lah1e_k$(destination);
          tmp = destination;
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? this.lastChildren_1 : tmp1_elvis_lhs;
      }
      appendChild_gtildm_k$(element) {
        assertSizeMatch(this);
        this.lastChildren_1.add_utx5q5_k$(element);
        var tmp0_safe_receiver = this.element_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          tmp0_safe_receiver.appendChild(element.create_md4cuc_k$());
        }
        assertSizeMatch(this);
      }
      appendChild_9oez1i_k$(index, element) {
        assertSizeMatch(this);
        if (index > this.lastChildren_1.get_size_woubt6_k$())
          throw IllegalStateException().new_kotlin_IllegalStateException_1wtnp1_k$();
        this.lastChildren_1.add_dl6gt3_k$(index, element);
        var tmp0_safe_receiver = this.element_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver_0 = tmp0_safe_receiver.children.item(index);
          var tmp;
          if (tmp0_safe_receiver_0 == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp = tmp0_safe_receiver.insertBefore(element.create_md4cuc_k$(), tmp0_safe_receiver_0);
          }
          tmp == null && tmp0_safe_receiver.appendChild(element.create_md4cuc_k$());
        }
        assertSizeMatch(this);
      }
      removeChild_mjbjbk_k$(index) {
        assertSizeMatch(this);
        this.lastChildren_1.removeAt_6niowx_k$(index);
        var tmp0_safe_receiver = this.element_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver_0 = tmp0_safe_receiver.children.item(index);
          var tmp;
          if (tmp0_safe_receiver_0 == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp = tmp0_safe_receiver.removeChild(tmp0_safe_receiver_0);
          }
        }
        assertSizeMatch(this);
      }
      clearChildren_eufjq4_k$() {
        assertSizeMatch(this);
        this.lastChildren_1.clear_j9egeb_k$();
        var tmp0_safe_receiver = this.element_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.innerHTML = '';
        }
        assertSizeMatch(this);
      }
    }
    initMetadataForClass($, 'FutureElement', FutureElement);
    FutureElementClass = $;
  }
  return FutureElementClass;
}
var FutureElementStyleClass;
function FutureElementStyle() {
  if (FutureElementStyleClass === VOID) {
    class $ {
      constructor(native) {
        this.native_1 = native;
      }
    }
    initMetadataForClass($, 'FutureElementStyle');
    FutureElementStyleClass = $;
  }
  return FutureElementStyleClass;
}
var FutureElementAttributesClass;
function FutureElementAttributes() {
  if (FutureElementAttributesClass === VOID) {
    class $ {
      constructor(native) {
        this.native_1 = native;
      }
    }
    initMetadataForClass($, 'FutureElementAttributes');
    FutureElementAttributesClass = $;
  }
  return FutureElementAttributesClass;
}
function forEach(receiver, action) {
  var _iterator__ex2g4s = iterator(Object.keys(receiver));
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var key = _iterator__ex2g4s.next_20eer_k$();
    action(key, receiver[key]);
  }
}
function remove(receiver, key) {
  delete receiver[key];
}
function nativeSetDragData(_this__u8e3s4, data) {
  // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
  var this_0 = _this__u8e3s4.native_1;
  var tmp0_safe_receiver = this_0.element_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    if (!(data == null)) {
      var tmp_0 = tmp0_safe_receiver instanceof HTMLElement ? tmp0_safe_receiver : THROW_CCE();
      tmp_0.ondragstart = (event) => {
        event.stopPropagation();
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = data.typeToData_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var _destruct__k2r9zo = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.collections.component1' call
          var type = _destruct__k2r9zo.get_key_18j28a_k$();
          // Inline function 'kotlin.collections.component2' call
          var value = _destruct__k2r9zo.get_value_j01efc_k$();
          ensureNotNull(event.dataTransfer).setData(type, value);
          var tmp0_safe_receiver = data.dragShadow_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
            var this_0 = get_native(tmp0_safe_receiver.view_1);
            var tmp0_safe_receiver_0 = this_0.element_1;
            var tmp;
            if (tmp0_safe_receiver_0 == null) {
              tmp = null;
            } else {
              // Inline function 'kotlin.let' call
              var tmp_0 = ensureNotNull(event.dataTransfer);
              var tmp_1;
              switch (tmp0_safe_receiver.xAlign_1.ordinal_1) {
                case 0:
                  tmp_1 = 0;
                  break;
                case 1:
                case 3:
                  tmp_1 = roundToInt(tmp0_safe_receiver_0.getBoundingClientRect().width / 2);
                  break;
                case 2:
                  tmp_1 = roundToInt(tmp0_safe_receiver_0.getBoundingClientRect().width);
                  break;
                default:
                  noWhenBranchMatchedException();
                  break;
              }
              var tmp_2 = tmp_1;
              var tmp1_safe_receiver = tmp0_safe_receiver.xOffset_1;
              var tmp_3;
              var tmp_4 = tmp1_safe_receiver;
              if ((tmp_4 == null ? null : new (Dimension())(tmp_4)) == null) {
                tmp_3 = null;
              } else {
                tmp_3 = get_px(tmp1_safe_receiver);
              }
              var tmp2_safe_receiver = tmp_3;
              var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : roundToInt(tmp2_safe_receiver);
              var tmp_5 = tmp_2 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
              var tmp_6;
              switch (tmp0_safe_receiver.yAlign_1.ordinal_1) {
                case 0:
                  tmp_6 = 0;
                  break;
                case 1:
                case 3:
                  tmp_6 = roundToInt(tmp0_safe_receiver_0.getBoundingClientRect().height / 2);
                  break;
                case 2:
                  tmp_6 = roundToInt(tmp0_safe_receiver_0.getBoundingClientRect().height);
                  break;
                default:
                  noWhenBranchMatchedException();
                  break;
              }
              var tmp_7 = tmp_6;
              var tmp5_safe_receiver = tmp0_safe_receiver.yOffset_1;
              var tmp_8;
              var tmp_9 = tmp5_safe_receiver;
              if ((tmp_9 == null ? null : new (Dimension())(tmp_9)) == null) {
                tmp_8 = null;
              } else {
                tmp_8 = get_px(tmp5_safe_receiver);
              }
              var tmp6_safe_receiver = tmp_8;
              var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : roundToInt(tmp6_safe_receiver);
              tmp_0.setDragImage(tmp0_safe_receiver_0, tmp_5, tmp_7 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0);
              tmp = Unit_instance;
            }
            if (tmp == null) {
              this_0.elementToDo_1.add_utx5q5_k$(nativeSetDragData$lambda$lambda(event, tmp0_safe_receiver));
            }
          }
        }
        return Unit_instance;
      };
    } else {
      (tmp0_safe_receiver instanceof HTMLElement ? tmp0_safe_receiver : THROW_CCE()).ondragstart = null;
      tmp0_safe_receiver.ondragend = null;
    }
    tmp = Unit_instance;
  }
  if (tmp == null) {
    this_0.elementToDo_1.add_utx5q5_k$((it) => {
      if (!(data == null)) {
        var tmp = it instanceof HTMLElement ? it : THROW_CCE();
        tmp.ondragstart = (event) => {
          event.stopPropagation();
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s = data.typeToData_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var _destruct__k2r9zo = _iterator__ex2g4s.next_20eer_k$();
            // Inline function 'kotlin.collections.component1' call
            var type = _destruct__k2r9zo.get_key_18j28a_k$();
            // Inline function 'kotlin.collections.component2' call
            var value = _destruct__k2r9zo.get_value_j01efc_k$();
            ensureNotNull(event.dataTransfer).setData(type, value);
            var tmp0_safe_receiver = data.dragShadow_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
              var this_0 = get_native(tmp0_safe_receiver.view_1);
              var tmp0_safe_receiver_0 = this_0.element_1;
              var tmp;
              if (tmp0_safe_receiver_0 == null) {
                tmp = null;
              } else {
                // Inline function 'kotlin.let' call
                var tmp_0 = ensureNotNull(event.dataTransfer);
                var tmp_1;
                switch (tmp0_safe_receiver.xAlign_1.ordinal_1) {
                  case 0:
                    tmp_1 = 0;
                    break;
                  case 1:
                  case 3:
                    tmp_1 = roundToInt(tmp0_safe_receiver_0.getBoundingClientRect().width / 2);
                    break;
                  case 2:
                    tmp_1 = roundToInt(tmp0_safe_receiver_0.getBoundingClientRect().width);
                    break;
                  default:
                    noWhenBranchMatchedException();
                    break;
                }
                var tmp_2 = tmp_1;
                var tmp1_safe_receiver = tmp0_safe_receiver.xOffset_1;
                var tmp_3;
                var tmp_4 = tmp1_safe_receiver;
                if ((tmp_4 == null ? null : new (Dimension())(tmp_4)) == null) {
                  tmp_3 = null;
                } else {
                  tmp_3 = get_px(tmp1_safe_receiver);
                }
                var tmp2_safe_receiver = tmp_3;
                var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : roundToInt(tmp2_safe_receiver);
                var tmp_5 = tmp_2 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
                var tmp_6;
                switch (tmp0_safe_receiver.yAlign_1.ordinal_1) {
                  case 0:
                    tmp_6 = 0;
                    break;
                  case 1:
                  case 3:
                    tmp_6 = roundToInt(tmp0_safe_receiver_0.getBoundingClientRect().height / 2);
                    break;
                  case 2:
                    tmp_6 = roundToInt(tmp0_safe_receiver_0.getBoundingClientRect().height);
                    break;
                  default:
                    noWhenBranchMatchedException();
                    break;
                }
                var tmp_7 = tmp_6;
                var tmp5_safe_receiver = tmp0_safe_receiver.yOffset_1;
                var tmp_8;
                var tmp_9 = tmp5_safe_receiver;
                if ((tmp_9 == null ? null : new (Dimension())(tmp_9)) == null) {
                  tmp_8 = null;
                } else {
                  tmp_8 = get_px(tmp5_safe_receiver);
                }
                var tmp6_safe_receiver = tmp_8;
                var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : roundToInt(tmp6_safe_receiver);
                tmp_0.setDragImage(tmp0_safe_receiver_0, tmp_5, tmp_7 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0);
                tmp = Unit_instance;
              }
              if (tmp == null) {
                this_0.elementToDo_1.add_utx5q5_k$(nativeSetDragData$lambda$lambda$lambda(event, tmp0_safe_receiver));
              }
            }
          }
          return Unit_instance;
        };
      } else {
        (it instanceof HTMLElement ? it : THROW_CCE()).ondragstart = null;
        it.ondragend = null;
      }
      return Unit_instance;
    });
  }
}
function nativeOnDrop(_this__u8e3s4, listener) {
  // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
  var this_0 = _this__u8e3s4.native_1;
  var tmp0_safe_receiver = this_0.element_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var it = tmp0_safe_receiver;
    if (!(listener == null)) {
      if (!(it instanceof HTMLElement))
        THROW_CCE();
      it.ondragover = (e) => {
        var tmp;
        if (listener.over_pubgvv_k$(nativeOnDrop$toDragEvent(e))) {
          e.preventDefault();
          e.stopPropagation();
          tmp = Unit_instance;
        }
        return Unit_instance;
      };
      it.ondragenter = (e) => {
        var relatedTarget = e.relatedTarget;
        var tmp;
        if (relatedTarget == null) {
          tmp = true;
        } else {
          tmp = !it.contains(relatedTarget instanceof Node ? relatedTarget : null);
        }
        var fromOutside = tmp;
        var shouldPreventDefault = fromOutside ? listener.enter_5nrpdt_k$(nativeOnDrop$toDragEvent(e)) : true;
        var tmp_0;
        if (shouldPreventDefault) {
          e.preventDefault();
          e.stopPropagation();
          tmp_0 = Unit_instance;
        }
        return Unit_instance;
      };
      it.ondragleave = (e) => {
        var relatedTarget = e.relatedTarget;
        var tmp;
        if (relatedTarget == null) {
          tmp = true;
        } else {
          tmp = !it.contains(relatedTarget instanceof Node ? relatedTarget : null);
        }
        var toOutside = tmp;
        var shouldPreventDefault = toOutside ? listener.exit_1yalkr_k$(nativeOnDrop$toDragEvent(e)) : true;
        var tmp_0;
        if (shouldPreventDefault) {
          e.preventDefault();
          e.stopPropagation();
          tmp_0 = Unit_instance;
        }
        return Unit_instance;
      };
      it.ondragend = (e) => {
        var tmp;
        if (listener.end_keguu6_k$(nativeOnDrop$toDragEvent(e))) {
          e.preventDefault();
          e.stopPropagation();
          tmp = Unit_instance;
        }
        return Unit_instance;
      };
      it.ondrop = (e) => {
        var tmp;
        if (listener.drop_tc4way_k$(nativeOnDrop$toDragEvent(e))) {
          e.preventDefault();
          e.stopPropagation();
          tmp = Unit_instance;
        }
        return Unit_instance;
      };
    } else {
      (it instanceof HTMLElement ? it : THROW_CCE()).ondragover = null;
      it.ondragenter = null;
      it.ondragleave = null;
      it.ondragexit = null;
      it.ondrop = null;
    }
    tmp = Unit_instance;
  }
  if (tmp == null) {
    this_0.elementToDo_1.add_utx5q5_k$((it) => {
      var it_0 = it;
      if (!(listener == null)) {
        if (!(it_0 instanceof HTMLElement))
          THROW_CCE();
        it_0.ondragover = (e) => {
          var tmp;
          if (listener.over_pubgvv_k$(nativeOnDrop$toDragEvent(e))) {
            e.preventDefault();
            e.stopPropagation();
            tmp = Unit_instance;
          }
          return Unit_instance;
        };
        it_0.ondragenter = (e) => {
          var relatedTarget = e.relatedTarget;
          var tmp;
          if (relatedTarget == null) {
            tmp = true;
          } else {
            tmp = !it_0.contains(relatedTarget instanceof Node ? relatedTarget : null);
          }
          var fromOutside = tmp;
          var shouldPreventDefault = fromOutside ? listener.enter_5nrpdt_k$(nativeOnDrop$toDragEvent(e)) : true;
          var tmp_0;
          if (shouldPreventDefault) {
            e.preventDefault();
            e.stopPropagation();
            tmp_0 = Unit_instance;
          }
          return Unit_instance;
        };
        it_0.ondragleave = (e) => {
          var relatedTarget = e.relatedTarget;
          var tmp;
          if (relatedTarget == null) {
            tmp = true;
          } else {
            tmp = !it_0.contains(relatedTarget instanceof Node ? relatedTarget : null);
          }
          var toOutside = tmp;
          var shouldPreventDefault = toOutside ? listener.exit_1yalkr_k$(nativeOnDrop$toDragEvent(e)) : true;
          var tmp_0;
          if (shouldPreventDefault) {
            e.preventDefault();
            e.stopPropagation();
            tmp_0 = Unit_instance;
          }
          return Unit_instance;
        };
        it_0.ondragend = (e) => {
          var tmp;
          if (listener.end_keguu6_k$(nativeOnDrop$toDragEvent(e))) {
            e.preventDefault();
            e.stopPropagation();
            tmp = Unit_instance;
          }
          return Unit_instance;
        };
        it_0.ondrop = (e) => {
          var tmp;
          if (listener.drop_tc4way_k$(nativeOnDrop$toDragEvent(e))) {
            e.preventDefault();
            e.stopPropagation();
            tmp = Unit_instance;
          }
          return Unit_instance;
        };
      } else {
        (it_0 instanceof HTMLElement ? it_0 : THROW_CCE()).ondragover = null;
        it_0.ondragenter = null;
        it_0.ondragleave = null;
        it_0.ondragexit = null;
        it_0.ondrop = null;
      }
      return Unit_instance;
    });
  }
}
function nativeScrollIntoView(_this__u8e3s4, horizontal, vertical, animate) {
  var tmp0_safe_receiver = _this__u8e3s4.native_1.element_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp0 = logicalPosition(vertical);
    var tmp2 = logicalPosition(horizontal);
    var tmp;
    if (animate) {
      // Inline function 'org.w3c.dom.SMOOTH' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = 'smooth';
    } else {
      // Inline function 'org.w3c.dom.INSTANT' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = 'instant';
    }
    // Inline function 'org.w3c.dom.ScrollIntoViewOptions' call
    var behavior = tmp;
    var o = {};
    o['block'] = tmp0;
    o['inline'] = tmp2;
    o['behavior'] = behavior;
    tmp0_safe_receiver.scrollIntoView(o);
  }
}
function logicalPosition(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4 == null ? -1 : _this__u8e3s4.ordinal_1) {
    case 0:
      // Inline function 'org.w3c.dom.START' call

      // Inline function 'kotlin.js.asDynamic' call

      // Inline function 'kotlin.js.unsafeCast' call

      tmp = 'start';
      break;
    case 1:
      // Inline function 'org.w3c.dom.CENTER' call

      // Inline function 'kotlin.js.asDynamic' call

      // Inline function 'kotlin.js.unsafeCast' call

      tmp = 'center';
      break;
    case 2:
      // Inline function 'org.w3c.dom.END' call

      // Inline function 'kotlin.js.asDynamic' call

      // Inline function 'kotlin.js.unsafeCast' call

      tmp = 'end';
      break;
    case 3:
      // Inline function 'org.w3c.dom.START' call

      // Inline function 'kotlin.js.asDynamic' call

      // Inline function 'kotlin.js.unsafeCast' call

      tmp = 'start';
      break;
    case -1:
      // Inline function 'org.w3c.dom.NEAREST' call

      // Inline function 'kotlin.js.asDynamic' call

      // Inline function 'kotlin.js.unsafeCast' call

      tmp = 'nearest';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function nativeSetDragData$lambda$lambda($event, $shadow) {
  return (it) => {
    var tmp = ensureNotNull($event.dataTransfer);
    var tmp_0;
    switch ($shadow.xAlign_1.ordinal_1) {
      case 0:
        tmp_0 = 0;
        break;
      case 1:
      case 3:
        tmp_0 = roundToInt(it.getBoundingClientRect().width / 2);
        break;
      case 2:
        tmp_0 = roundToInt(it.getBoundingClientRect().width);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp_1 = tmp_0;
    var tmp1_safe_receiver = $shadow.xOffset_1;
    var tmp_2;
    var tmp_3 = tmp1_safe_receiver;
    if ((tmp_3 == null ? null : new (Dimension())(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      tmp_2 = get_px(tmp1_safe_receiver);
    }
    var tmp2_safe_receiver = tmp_2;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : roundToInt(tmp2_safe_receiver);
    var tmp_4 = tmp_1 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_5;
    switch ($shadow.yAlign_1.ordinal_1) {
      case 0:
        tmp_5 = 0;
        break;
      case 1:
      case 3:
        tmp_5 = roundToInt(it.getBoundingClientRect().height / 2);
        break;
      case 2:
        tmp_5 = roundToInt(it.getBoundingClientRect().height);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp_6 = tmp_5;
    var tmp5_safe_receiver = $shadow.yOffset_1;
    var tmp_7;
    var tmp_8 = tmp5_safe_receiver;
    if ((tmp_8 == null ? null : new (Dimension())(tmp_8)) == null) {
      tmp_7 = null;
    } else {
      tmp_7 = get_px(tmp5_safe_receiver);
    }
    var tmp6_safe_receiver = tmp_7;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : roundToInt(tmp6_safe_receiver);
    tmp.setDragImage(it, tmp_4, tmp_6 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0);
    return Unit_instance;
  };
}
function nativeSetDragData$lambda$lambda$lambda($event, $shadow) {
  return (it) => {
    var tmp = ensureNotNull($event.dataTransfer);
    var tmp_0;
    switch ($shadow.xAlign_1.ordinal_1) {
      case 0:
        tmp_0 = 0;
        break;
      case 1:
      case 3:
        tmp_0 = roundToInt(it.getBoundingClientRect().width / 2);
        break;
      case 2:
        tmp_0 = roundToInt(it.getBoundingClientRect().width);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp_1 = tmp_0;
    var tmp1_safe_receiver = $shadow.xOffset_1;
    var tmp_2;
    var tmp_3 = tmp1_safe_receiver;
    if ((tmp_3 == null ? null : new (Dimension())(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      tmp_2 = get_px(tmp1_safe_receiver);
    }
    var tmp2_safe_receiver = tmp_2;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : roundToInt(tmp2_safe_receiver);
    var tmp_4 = tmp_1 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_5;
    switch ($shadow.yAlign_1.ordinal_1) {
      case 0:
        tmp_5 = 0;
        break;
      case 1:
      case 3:
        tmp_5 = roundToInt(it.getBoundingClientRect().height / 2);
        break;
      case 2:
        tmp_5 = roundToInt(it.getBoundingClientRect().height);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp_6 = tmp_5;
    var tmp5_safe_receiver = $shadow.yOffset_1;
    var tmp_7;
    var tmp_8 = tmp5_safe_receiver;
    if ((tmp_8 == null ? null : new (Dimension())(tmp_8)) == null) {
      tmp_7 = null;
    } else {
      tmp_7 = get_px(tmp5_safe_receiver);
    }
    var tmp6_safe_receiver = tmp_7;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : roundToInt(tmp6_safe_receiver);
    tmp.setDragImage(it, tmp_4, tmp_6 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0);
    return Unit_instance;
  };
}
function nativeOnDrop$toDragEvent(_this__u8e3s4) {
  // Inline function 'kotlin.collections.associate' call
  var this_0 = ensureNotNull(_this__u8e3s4.dataTransfer).types;
  var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(element, ensureNotNull(_this__u8e3s4.dataTransfer).getData(element));
    destination.put_4fpzoq_k$(pair.first_1, pair.second_1);
  }
  return new (DragEvent())(DragData().new_com_lightningkite_kiteui_models_DragData_1zeh93_k$('', destination), _this__u8e3s4.x, _this__u8e3s4.y);
}
//region block: exports
export {
  FutureElement as FutureElement3o36ukl4wk2br,
  nativeOnDrop as nativeOnDrop30134938gsti8,
  nativeScrollIntoView as nativeScrollIntoView1t8wmo7ny7ja1,
  nativeSetDragData as nativeSetDragData3rhkgkz3i4r34,
};
//endregion

//# sourceMappingURL=NativeElement.commonHtml.js.mjs.map
